import { render, staticRenderFns } from "./EmailCode.vue?vue&type=template&id=cf9971e8&scoped=true&"
import script from "./EmailCode.vue?vue&type=script&lang=js&"
export * from "./EmailCode.vue?vue&type=script&lang=js&"
import style0 from "./EmailCode.vue?vue&type=style&index=0&id=cf9971e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9971e8",
  null
  
)

export default component.exports